<template>
  <div class="content blacklist">
    <div class="header">
      <el-button type="primary" size="small" @click="dialogFormVisible = true">设置班次</el-button>
    </div>
    <template>
      <el-table :data="tableData" style="width: 100%" size="small" :header-cell-style="setTableHeader">
        <el-table-column type="index" label="#" width="180"></el-table-column>
        <el-table-column prop="name" label="班次名称" align="center"></el-table-column>
        <el-table-column prop="start_time" label="上班时间" align="center"></el-table-column>
        <el-table-column prop="show_end_time" label="下班时间" align="center"></el-table-column>
        
      </el-table>
    </template>
    <!--  添加关键词 -->
    <el-dialog title="设置班次" :visible.sync="dialogFormVisible" width="600px">
      <el-form label-width="100px">
        <el-form-item v-for="(item,index) in form" :key="index" :label="'班次'+(index+1)">
          <div class="part_box">
            <div class="part_title">班次名称</div>
            <div class="part_value">
              <el-input v-model="item.name" size="small"></el-input>
            </div>
            <span style="margin-left:10px" v-if="index != 0">
              <el-button type="text" @click="delPart(index)">删除</el-button>
            </span>
          </div>
          <div class="part_box">
            <div class="part_title">上班时间</div>
            <div class="part_value">
              <el-time-select
                size="small"
                v-model="item.start_time"
                :picker-options="{
                  start: '00:00',
                  step: '00:15',
                  end: '23:45'
                }"
                @change="resetTime(index,1)">
              </el-time-select>
            </div>
          </div>
          <div class="part_box">
            <div class="part_title">下班时间</div>
            <div class="part_value" v-if="item.show_time">次日{{item.end_time}}</div>
            <div class="part_value" v-else>
              <el-time-select
                size="small"
                v-model="item.end_time"
                :picker-options="{
                  start: '00:00',
                  step: '00:15',
                  end: '23:45'
                }"
                @change="resetTime(index,2)">
              </el-time-select>
            </div>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button @click="addPart()" size="small" type="primary">添加班次</el-button>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="showConfirm()" size="small">保 存</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="showMsg" title="确认班次信息" @close="showMsg=false" width="500px">
      <el-table :data="form">
        <el-table-column label="班次名称" prop="name" align="center"></el-table-column>
        <el-table-column label="上班时间" prop="start_time" align="center"></el-table-column>
        <el-table-column label="下班时间">
          <template slot-scope="scope" align="center">
            <div>{{scope.row.type == 1? "次日":""}}{{scope.row.end_time}}</div>
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align:center;margin-top:20px">
        <el-button type="" size="small">取消</el-button>
        <el-button type="primary" size="small" @click="save">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { classSetList, classSetAdd, classSetEdit } from "@/api/vip"
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      page_id: "",
      tableData: [],  //表格数据
      dialogFormVisible: false,  //设置弹窗
      form: [],  //设置表单
      showMsg: false,  //显示确认弹窗
      seted: false,  //是否已设置过
      setId: "", //已设置过的id
    };
  },
  mounted() {
    this.page_id = this.$route.params.id;
    this.init();
  },
  methods:{
    init(){
      classSetList({token:this.token,app_id:this.app_id}).then(res => {
        if(res.code == 200){
          if(res.data.length){
            this.tableData = res.data[0].rule;
            this.setId = res.data[0].id;
            this.form = [];
            this.tableData.forEach(item => {
              var i = {
                name: item.name,
                start_time: item.start_time,
                end_time: item.end_time,
                show_time: false
              }
              this.form.push(i);
              item.show_end_time = item.type == 1? "次日"+item.end_time:item.end_time;
            })
            this.form[this.form.length-1].show_time = true;
            this.seted = true;
          }else{
            this.initForm();
          }
        }else{
          this.$message(res.msg);
          this.initForm();
        }
      })
    },
    initForm(){
      this.form = [{
        name: '白班',
        start_time: '08:00',
        end_time: '20:00',
        show_time:false
      },{
        name: '夜班',
        start_time: '20:00',
        end_time: "08:00",
        show_time:true
      }];
      this.form[this.form.length-1].end_time = this.form[0].start_time
    },
    addPart(){ //添加班次
      this.form[this.form.length-1].show_time = false;
      var i = {
        name: "",
        show_time: true
      }
      i.start_time = this.form[this.form.length-1].end_time;
      i.end_time = this.form[0].start_time;
      this.form.push(i);
    },
    resetTime(index,type){ //设置时间联动
      console.log(type)
      if(type == 1){
        if(index == 0){
          this.form[this.form.length-1].end_time = this.form[0].start_time;
        }else{
          this.form[index-1].end_time = this.form[index].start_time;
        }
      }else{
        this.form[index+1].start_time = this.form[index].end_time;
      }
    },
    delPart(i){ //删除班次
      this.form.splice(i,1);
      this.form[this.form.length-1].show_time = true;
      this.form[this.form.length-1].end_time = this.form[0].start_time;
    },
    showConfirm(){ //确认保存
      this.form.forEach(item => {
        item.next_day = 0;
      })
      this.form[this.form.length-1].next_day = 1;
      this.showMsg = true;
      // this.dialogFormVisible = false;
    },
    save(){
      var data = {
        token: this.token,
        app_id: this.app_id,
      }
      var list = []
      this.form.forEach(item => {
        var i = {
          name: item.name,
          start_time: item.start_time,
          end_time: item.end_time,
          type: item.next_day
        }
        list.push(i);
      })
      data.rule = list;
      console.log(data);
      if(this.seted){
        data.id = this.setId;
        classSetEdit(data).then(res => {
          if(res.code == 200){
            this.$message({
              type: "success",
              message: "修改成功"
            })
            this.dialogFormVisible = false;
            this.showMsg = false;
            this.init();
          }else{
            this.$message(res.msg);
          }
        })
      }else{
        classSetAdd(data).then(res => {
          if(res.code == 200){
            this.$message({
              type: "success",
              message: "保存成功"
            })
            this.dialogFormVisible = false;
            this.showMsg = false;
            this.init();
          }else{
            this.$message(res.msg);
          }
        })
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.content {
  padding: 0 55px 30px 0;
  height: calc(100vh - 102px);
  border: 1px solid #f1f1f1;
  overflow: auto;
  min-width: 900px;
  // box-shadow: 0 0 3px #f1f1f1;
}
.blacklist {
  padding: 10px 25px;
  .header {
    border-bottom: 0;
    position: relative;
    padding-left: 24px;
    margin-bottom: 15px;
    padding: 10px 15px;
  }
  .img {
    width: 100%;
    height: 100px;
    text-align: center;
    line-height: 100px;
    img {
      width: 80%;
    }
  }
}
.part_box{
  margin-bottom:10px;
  .part_title{
    width: 80px;
    display: inline-block;
  }
  .part_value{
    display: inline-block;
  }
}
</style>